import React from "react";
import GridTable from "pages/_components/GridTable/GridTable";
import I18n from "pages/_components/I18n";
import { bool } from "prop-types";

const DetailDiscountsTitleColumns = ({ showStatus }) => (
    <>
        <GridTable.Data columnStart={1} rowStart={1} alignX="start" rowWidth={1}>
            <I18n component="span" id="detail.discounts.recibedTo" />
        </GridTable.Data>
        <GridTable.Data columnStart={2} rowStart={1} alignX="center" rowWidth={1}>
            <I18n component="span" id="detail.discounts.idEcheq" />
        </GridTable.Data>
        <GridTable.Data columnStart={3} rowStart={1} alignX="center" rowWidth={1}>
            <I18n component="span" id="detail.discounts.emitter" />
        </GridTable.Data>
        <GridTable.Data columnStart={4} rowStart={1} alignX="center" rowWidth={1}>
            <I18n component="span" id="detail.discounts.amount" />
        </GridTable.Data>
        {!!showStatus && (
            <GridTable.Data columnStart={5} rowStart={1} alignX="center" rowWidth={1}>
                <I18n component="span" id="discounts.echeqTable" defaultValue="Estado" />
            </GridTable.Data>
        )}
    </>
);

DetailDiscountsTitleColumns.propTypes = {
    showStatus: bool.isRequired,
};

export default DetailDiscountsTitleColumns;
